import { render, staticRenderFns } from "./RightNavbar.vue?vue&type=template&id=022e0415&"
import script from "./RightNavbar.vue?vue&type=script&lang=js&"
export * from "./RightNavbar.vue?vue&type=script&lang=js&"
import style0 from "./RightNavbar.vue?vue&type=style&index=0&id=022e0415&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports